import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateRateCardRequest extends BaseUpdateRequest {
    name = '';
    driverUnitExpenseChargeRate = 0;

}